export default "__VITE_ASSET__c4f5f315__"